// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3odqB","hide-content":"ZOKAD","read-more":"y08vR"};